// @ts-nocheck
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AddJob from './AddJob.jsx';
import { Card, CardBody } from '@components/card/card.jsx';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getJobs } from '@store/HR/HRSetting/jobSlice.js';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
// import withGuard from '@Helper/withGuard.jsx';
import Loading from '@components/Shared/Loader/Loading';
import Breadcrumb from '@components/Shared/Breadcrumb';
import ModalComponent from '@components/Modal/ModalComponent.jsx';
import NtxTable from '@components/DataTable/NtxTable.jsx';
import EditJob from './EditJob.jsx';

// const Job = () => {
//   const { HasPermission } = usePermissions();
//   const [id, setId] = useState('');

//   const [Show, setShow] = useState(false);
//   const { t, i18n } = useTranslation();

//   const { Jobs, loading, error } = useSelector(state => state.Jobs);
//   const dispatch = useDispatch();
//   useEffect(() => {
//     if (Jobs?.length === 0) {
//       dispatch(getJobs());
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~`

//   const columns = [
//     { title: t('Name'), key: 'Name' },
//     { title: t(''), key: 'action', className: 'text-end' }
//   ];

//   const tableData = Jobs?.map(item => {
//     let rowClass;

//     return {
//       Name: i18n.language === 'ar' ? item.name : item.name2,
//       action: (
//         <>
//           {HasPermission('ViewDetailsHrPerJob') && (
//             <button
//               type='button'
//               className='btn btn-sm btn-outline-theme'
//               data-bs-toggle='modal'
//               data-bs-target='#Update'
//               onClick={() => setId(item.id)}
//             >
//               <i className='far fa-lg fa-fw  fa-edit mx-1'></i>
//               {t('Button.Edit')}
//             </button>
//           )}
//         </>
//       ),

//       rowClass // استخدم rowClass هنا
//     };
//   });

//   //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~`
//   var BcrumbList = [
//     {
//       name: 'Home',
//       link: ':moduleHome'
//     },
//     {
//       name: t('Jobs'),
//       link: null
//     }
//   ];
//   return (
//     <>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('Jobs')} />
//         {HasPermission('AddHrPerJob') && (
//           <div className='ms-auto'>
//             <Link
//               to=''
//               className='btn me-1 btn-theme'
//               data-bs-toggle='modal'
//               data-bs-target='#modalِAddJob'
//               onClick={() => setShow(true)}
//             >
//               <i className='fa fa-plus-circle fa-fw me-1'></i>
//               {t('AddNewJob')}
//             </Link>
//           </div>
//         )}
//       </div>

//       <Card>
//         <Loading loading={loading} error={error}>
//           <CardBody>
//             <NtxTable
//               data={tableData || []}
//               columns={columns}
//               dataPerPage={10}
//               theadClass=''
//               tableClass='table text-nowrap table-hover '
//               enableSearch
//               showRecordsSelector
//             />
//           </CardBody>
//         </Loading>
//       </Card>

//       <ModalComponent title={t('AddJob')} id='modalِAddJob' size='lg'>
//         {Show && <AddJob />}
//       </ModalComponent>

//       <ModalComponent id='Update' title={t('EditJob')} size='lg'>
//         {id && <EditJob id={id} />}
//       </ModalComponent>
//     </>
//   );
// };

const Job = () => {
  const { HasPermission } = usePermissions();
  const [id, setId] = useState('');

  const [Show, setShow] = useState(false);
  const { t, i18n } = useTranslation();

  const { Jobs, loading, error } = useSelector(state => state.Jobs);
  const dispatch = useDispatch();
  useEffect(() => {
    if (Jobs?.length === 0) {
      dispatch(getJobs());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~`

  const columns = [
    { title: t('Code'), key: 'Code' }, // Added Code column
    { title: t('Name'), key: 'Name' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = Jobs?.map(item => {
    let rowClass;

    return {
      Code: item.code, // Added Code field
      Name: i18n.language === 'ar' ? item.name : item.name2,
      action: (
        <>
          {HasPermission('ViewDetailsHrPerJob') && (
            <button
              type='button'
              className='btn btn-sm btn-outline-theme'
              data-bs-toggle='modal'
              data-bs-target='#Update'
              onClick={() => setId(item.id)}
            >
              <i className='far fa-lg fa-fw  fa-edit mx-1'></i>
              {t('Button.Edit')}
            </button>
          )}
        </>
      ),

      rowClass // استخدم rowClass هنا
    };
  });

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~`
  var BcrumbList = [
    {
      name: 'Home',
     link: ':moduleHome'
    },
    {
      name: t('Jobs'),
      link: null
    }
  ];
  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('Jobs')} />
        {HasPermission('AddHrPerJob') && (
          <div className='ms-auto'>
            <Link
              to=''
              className='btn me-1 btn-theme'
              data-bs-toggle='modal'
              data-bs-target='#modalِAddJob'
              onClick={() => setShow(true)}
            >
              <i className='fa fa-plus-circle fa-fw me-1'></i>
              {t('AddNewJob')}
            </Link>
          </div>
        )}
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('AddJob')} id='modalِAddJob' size='lg'>
        {Show && <AddJob />}
      </ModalComponent>

      <ModalComponent id='Update' title={t('EditJob')} size='lg'>
        {id && <EditJob id={id} />}
      </ModalComponent>
    </>
  );
};

export default Job;
 